<!-- <div class="d-none">
    <audio src="./../assets/music/background.mp3" id="music-background" loop>
    </audio>
    <audio id="music-buttons" src="./../assets/music/buttons.mp3" preload="auto"></audio>
    <audio id="music-icons" src="./../assets/music/icons.mp3" preload="auto"></audio>
    <audio id="music-links" src="./../assets/music/links.mp3" preload="auto"></audio>
    <audio id="music-menu" src="./../assets/music/menu.mp3" preload="auto"></audio>
    <audio id="music-services" src="./../assets/music/services.mp3" preload="auto"></audio>
    <audio id="music-team" src="./../assets/music/team.mp3" preload="auto"></audio>
</div> -->
<div class="hide-stuff"></div>
<app-loader></app-loader>
<!-- <app-construction></app-construction> -->
  
<app-nav currentPage={{currentPage}} isAbsolutePosition={{isAbsolutePosition}}></app-nav>
<router-outlet></router-outlet>
<app-footer></app-footer>
<div class="theme-pannel-main con-tooltip bottom js-trigger-tooltip d-none" id="trigger-tooltip">
    <div class="tooltip" id="tooltip">
        <p class="font-weight-bold font-italic text-center">{{'APP.THEME' | translate}}</p>
    </div>
    <ul class="link-sound">
        <li class="sidebar-btn dark-light-btn" *ngIf="customize.data.settings.layout_version == 'dark'"
            (click)="customizeLayoutVersion('light')">
            <div class="dark-light"><span class="theme-layout-version"><i class="fa fa-sun-o center-content"></i></span>
            </div>
        </li>
        <li class="sidebar-btn dark-light-btn" *ngIf="customize.data.settings.layout_version == 'light'"
            (click)="customizeLayoutVersion('dark')">
            <div class="dark-light"><span class="theme-layout-version"><i
                        class="fa fa-moon-o center-content"></i></span></div>
        </li>
    </ul>
</div>